import { ComponentProjectListRequestPageState } from ".";

export const displayColumn = [{ label: "Ticket", value: "tcktId" }];

export const ComponentProjectListRequestPageInitialState: ComponentProjectListRequestPageState =
  {
    cpntPjtList: [],
    generalCode: {
      inDefCommonFlagType: [],
      tcktStsTypeCpntPrjPrgrs: [],
      edhProtocolList: [],
    },
    isEdited: false,
    displayColumn: displayColumn,
    dipByRegion: "",
    componentId: "",
    fieldPath: {
      dipByRgn: "dipByRgn",
      rootCpntId: "rootCpntId",
      cpntId: "cpntId",
      pjtSts: "pjtSts",
    },
  };
